/**
 * 提示词直传（v1.12 简化，2026-09-18 按用户拍板）：
 * - 仅鱼眼/倾斜两个预设内置提示词文本（anglePresets.ts 的 promptText，点击预设时
 *   自动填入文本框并开启开关）；其余视角一律不自动使用提示词。
 * - 开关开启：prompt = 文本框内容原样直传（仅去首尾空白）；关闭：空串。
 * - 机位完全由结构化参数驱动（horizontal_angle / vertical_angle / distance），
 *   参数按用户所调原样吸附发送，不做任何补偿。
 * - 历史：v1.8~v1.11 的双通道（关闭发完整自动模板 / 开启叠加机位描述句）、
 *   鱼眼动态机位句与后端 -30° 俯拍先验补偿均已按用户要求移除。
 */
export function buildAnglePrompt(customPrompt: string | undefined, promptEnabled: boolean): string {
  return promptEnabled ? (customPrompt ?? '').trim() : '';
}
